<app-navbar-style-one></app-navbar-style-one>

<div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>Order apps </h2>
                    <p class="mt-4 mb-0 mx-3">Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/cart.png" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div>

<section class="orderAppsSection mt-2">
    <div class="container-fluid px-3">
        <div class="row" *ngIf="!isLoading">
            <div class="col-lg-4 col-md-6 col-sm-6 col-12 pt-3 text-center" *ngFor="let item of orderApps;let i = index">
                <div class="customCard">
                    <div class="text-center m-auto" style="width: 250px;height: 250px;">
                        <img [src]="item.image" [alt]="item.title" class="img-fluid" alt="Apps">
                    </div>
                    <a [href]="item.url" target="_blank" class="btn btn-primary">{{item.title}}</a>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="isLoading">
            <div class="col-12 text-center">
                <div class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>